import { call, put, takeLatest, delay } from "redux-saga/effects";
import {
  fetchDashboardFailure,
  fetchDashboardRequest,
  fetchDashboardSuccess,
} from "../slices/dashboardSlice";
import { SagaIterator } from "redux-saga";
const dailyData = [
  { name: "Mon", value: 200 },
  { name: "Tue", value: 300 },
  { name: "Wed", value: 400 },
  { name: "Thu", value: 250 },
  { name: "Fri", value: 500 },
  { name: "Sat", value: 600 },
  { name: "Sun", value: 700 },
];
const vehicleData = [
  { name: "Sedan", value: 400 },
  { name: "SUV", value: 300 },
  { name: "Truck", value: 200 },
  { name: "Coupe", value: 100 },
];
function* fetchDashboardData(): SagaIterator {
  try {
    yield delay(500);
    yield put(fetchDashboardSuccess({ dailyData, vehicleData }));
  } catch (error: any) {
    yield put(fetchDashboardFailure(error.message));
  }
}
export function* dashboardSaga(): SagaIterator {
  yield takeLatest(fetchDashboardRequest.type, fetchDashboardData);
}
